'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002440 from "./presto.-Two-Factor-Auth-View$$anon$40.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002442 from "./presto.-Two-Factor-Auth-View$$anon$42.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002444 from "./presto.-Two-Factor-Auth-View$$anon$44.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002446 from "./presto.-Two-Factor-Auth-View$$anon$46.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$39() {
  this.bCh = null;
  this.bC9 = null;
  this.bCa = false;
  this.bCi = null;
  this.bCj = false;
  this.bCm = null;
  this.bCf = null;
  this.bCg = false;
  this.bCb = null;
  this.bCc = false;
  this.bCd = null;
  this.bCe = false;
  this.bCk = false;
  this.bCl = false;
  this.bCh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bCm = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$39 as $c_Lpresto_TwoFactorAuthView$$anon$39 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$39.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$39;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$39() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$39 as $h_Lpresto_TwoFactorAuthView$$anon$39 };
$h_Lpresto_TwoFactorAuthView$$anon$39.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bCh;
});
$p.M = (function() {
  if ((!this.bCa)) {
    this.bC9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bCa = true;
  }
  return this.bC9;
});
$p.O = (function() {
  if ((!this.bCj)) {
    this.bCi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bCj = true;
  }
  return this.bCi;
});
$p.E = (function() {
  return this.bCm;
});
$p.t = (function() {
  if ((!this.bCg)) {
    this.bCf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bCg = true;
  }
  return this.bCf;
});
$p.N = (function() {
  if ((!this.bCc)) {
    this.bCb = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002440.$c_Lpresto_TwoFactorAuthView$$anon$40(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002442.$c_Lpresto_TwoFactorAuthView$$anon$42())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002444.$c_Lpresto_TwoFactorAuthView$$anon$44())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bCc = true;
  }
  return this.bCb;
});
$p.Q = (function() {
  if ((!this.bCe)) {
    this.bCd = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002446.$c_Lpresto_TwoFactorAuthView$$anon$46();
    this.bCe = true;
  }
  return this.bCd;
});
$p.v = (function() {
  if ((!this.bCl)) {
    this.bCk = false;
    this.bCl = true;
  }
  return this.bCk;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee443) => ((p) => \u03b4scrutinee443.z8(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$39 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$39, "presto.TwoFactorAuthView$$anon$39", ({
  SX: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$39 as $d_Lpresto_TwoFactorAuthView$$anon$39 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$39.js.map
